'use client';

import { atom } from 'jotai';

export const hasKwankoCookieApprovedAtom = atom(false);
